"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var slate_react_1 = require("slate-react");
var styles_1 = require("@material-ui/core/styles");
var MediaPlayer_1 = __importDefault(require("../../../MediaPlayer"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            backgroundColor: '#F0F4F8',
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        wrapper: {
            position: 'relative',
        },
        wrapperFocused: {
            boxShadow: '0 0 0 3px #B4D5FF',
        },
        cursorOverlay: {
            position: 'absolute',
            top: '0',
            left: '0',
            height: '100%',
            width: '100%',
            cursor: 'cell',
            zIndex: 1,
        },
        field: {
            display: 'flex',
            alignItems: 'center',
            background: 'transparent',
            boxShadow: 'none',
            width: '100%',
            textAlign: 'center',
            resize: 'none',
            outline: 'none',
            padding: 16,
            height: 54,
            fontSize: '16px',
            boxSizing: 'border-box',
            border: '2px solid #D9E2EC',
            borderRadius: 2,
        },
        caption: {
            fontSize: '12px',
            textAlign: 'center',
            margin: theme.spacing(1, 0),
        },
    });
});
var EditorEmbeddedMedia = function (_a) {
    var _b;
    var attributes = _a.attributes, children = _a.children, url = _a.url;
    var classes = exports.useStyles();
    var selected = slate_react_1.useSelected();
    var focused = slate_react_1.useFocused();
    return (react_1.default.createElement("div", __assign({}, attributes),
        react_1.default.createElement("div", { contentEditable: false, className: clsx_1.default(classes.wrapper, (_b = {},
                _b[classes.wrapperFocused] = selected && focused,
                _b)) },
            react_1.default.createElement("div", { className: classes.cursorOverlay, style: {
                    display: selected && focused ? 'none' : 'block',
                } }),
            react_1.default.createElement(MediaPlayer_1.default, { url: url })),
        children));
};
exports.default = EditorEmbeddedMedia;
//# sourceMappingURL=EditorEmbeddedMedia.js.map